module.exports = __webpack_public_path__ + "img/Gerster-Franz.jpg";